import React, {Component} from 'react';
import axios from 'axios'; 
import {   Link } from 'react-router-dom'; 
import {api_base_url, base_url} from '../common/Constants';

class Footer extends Component {

    constructor(){
        super();
        this.state = {
            
        }
    }
    componentDidMount()
    { 

       
    }

      
    render()
    {
        if (this.state.loading == 1) {
            return <div>Loading...</div>;
          }
 
  return (

        
            <footer className=" text-light border-right bg-theme"  style={{backgroundImage: ` url(assets/img/footer.png)`}} >
        <div className="container">
            <div className="row">
                <div className="f-items">

                    
                    <div className="col-md-4 col-sm-6 equal-height item">
                        <div className="f-item about">
							<img src={base_url+"assets/img/logo-light.png"} alt=""/>
<br />
                            <p>{JSON.parse(localStorage.getItem("settings")).site_footer_text}</p>
                            
                        </div>
                    </div>
                   
                    <div className="col-md-4 col-sm-6 equal-height item">
                        <div className="f-item link">
                            <h4>Useful Links</h4>
                            
                                    <Link to={base_url+`about-us`}>About us</Link><br />
							 		
							<Link to={base_url+`quality-policy`}>Quality and Safety</Link><br/> 
							<Link to={base_url+`projects`}>Major Projects</Link><br/>
							<Link to={base_url+`clients`}>Client Lists</Link><br/>
							<Link to={base_url+`machines`}>Cool Pro Machines</Link><br/>
                            <Link to={base_url+`careers`}>Careers</Link><br/>
                            <Link to={base_url+`contact`}>Contact us</Link>  
                        </div>
                    </div>
                    
                    <div className="col-md-4 col-sm-6 equal-height item">
                        <div className="f-item about">
                            <h4>Contact us</h4>
                            <ul>
								<li>
                                    <i className="fas fa-phone"></i> 
                                    <p>Head Office  <Link to={JSON.parse(localStorage.getItem("settings")).site_head_office_number}>{JSON.parse(localStorage.getItem("settings")).site_head_office_number}</Link>
									<span>Abu Dhabi  <Link to={JSON.parse(localStorage.getItem("settings")).site_factory_number}>{JSON.parse(localStorage.getItem("settings")).site_factory_number}</Link></span> </p>
                                </li>
                                <li>
                                    <i className="fas fa-envelope"></i> 
                                    <p> <Link to={JSON.parse(localStorage.getItem("settings")).site_email_address}>{JSON.parse(localStorage.getItem("settings")).site_email_address}</Link></p>
                                </li>
                                <li>
                                    <i className="fas fa-map"></i> 
                                    <p>Head Office : {JSON.parse(localStorage.getItem("settings")).site_head_office_address} <span> Abu Dhabi : {JSON.parse(localStorage.getItem("settings")).site_factory_address}
ICAD III, Mussafah,Abu Dhabi, UAE</span></p>
                                </li>
                            </ul>
                            
                        </div>
                    </div>
                   
                </div>
            </div>
        </div>
        
        
        <div className="footer-bottom bg-theme-small text-light">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <p>&copy; Copyright 2025. All Rights Reserved by Cool Pro</p>
                    </div>
                    <div className="col-md-6 text-right link">
                        
                    </div>
                </div>
            </div>
        </div>
       
    </footer>
 
);
}
};

export default Footer;